'use client'

import VideoPlayer from '@/components/content/videos/VideoPlayer'
import { usePageContext } from '@/components/content/common/PageContext'
import { isPopulatedObject } from '@/lib/utils'
import { createLogger } from '@/lib/logger'
import type { Video, VideoCategoriesCategory, VideoAppsApp } from '@/payload-types'

const logger = createLogger('BestVideoPlayer')

// Client island: the only thing that needs the client here is reading `playVideo`
// from PageContext for autoplay. Everything around it (title, footer, layout) is server.
export default function BestVideoPlayer({
  videoCategory,
  videoApps,
}: {
  videoCategory: VideoCategoriesCategory
  videoApps?: VideoAppsApp[]
}) {
  const { playVideo } = usePageContext()
  const video = videoCategory?.video

  if (!isPopulatedObject<Video>(video)) {
    logger.warn('video relationship is not populated on videoCategory; skipping player')
    return null
  }

  return (
    <VideoPlayer
      video={video}
      videoApps={videoApps}
      timestamp={videoCategory?.timestamp}
      timestampEnd={videoCategory?.timestampEnd}
      withTitle={false}
      autoPlay={playVideo}
    />
  )
}
